import type { StateCreator } from 'zustand';
import type { ShortlistEntry } from '@gpa-scales/shared-types';

export interface ShortlistSlice {
  collegeShortlist: ShortlistEntry[];
  toggleShortlist: (entry: ShortlistEntry) => void;
  removeFromShortlist: (key: string) => void;
  clearShortlist: () => void;
}

export const createShortlistSlice: StateCreator<ShortlistSlice> = (set) => ({
  collegeShortlist: [],
  toggleShortlist: (entry) =>
    set((state) => {
      const exists = state.collegeShortlist.some((e) => e.key === entry.key);
      return {
        collegeShortlist: exists
          ? state.collegeShortlist.filter((e) => e.key !== entry.key)
          : [...state.collegeShortlist, entry],
      };
    }),
  removeFromShortlist: (key) =>
    set((state) => ({
      collegeShortlist: state.collegeShortlist.filter((e) => e.key !== key),
    })),
  clearShortlist: () => set({ collegeShortlist: [] }),
});
